export const RANGE_GRANULARITIES = [
  'year',
  'fiscalYear',
  'quarter',
  'month',
  'custom',
] as const;
export type RangeGranularity = (typeof RANGE_GRANULARITIES)[number];

export const RANGE_PRESETS = [
  'yearToDate',
  'today',
  'yesterday',
  'thisWeek',
  'thisMonth',
  'fiscalYear',
  'allTime',
  'thisQuarter',
  'lastQuarter',
  'thisYear',
  'lastYear',
  'last30Days',
  'last90Days',
] as const;
export type RangePreset = (typeof RANGE_PRESETS)[number];

export const COMPARISON_MODES = [
  'previousYear',
  'previousPeriod',
  'none',
  'custom',
] as const;
export type ComparisonMode = (typeof COMPARISON_MODES)[number];

export interface DateRangeValue {
  from: Date;
  to: Date;
}

export interface DateRangeComparisonValue {
  range: DateRangeValue;
  comparison: DateRangeValue | null;
  granularity: RangeGranularity;
  preset: RangePreset | null;
  comparisonMode: ComparisonMode;
}
